import IMask from 'imask';

import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="phone-mask"
export default class extends Controller {
  connect() {
    if (this.element.tagName !== 'INPUT') {
      console.error('Element is not input');
      return;
    }

    IMask(this.element, {
      mask: '{8} (000) 000-00-00',
      lazy: false,            // make placeholder always visible
      // placeholderChar: '_'    // defaults to '_'
    })
  }
}
